import { useAiReceptionistOrgLocations } from './use-ai-receptionist-org-locations';
import { useCheckAiReceptionistDemoAccount } from './use-check-ai-receptionist-demo-account';

export const useShowAiReceptionistAnalyticsNav = () => {
  const isDemoAccount = useCheckAiReceptionistDemoAccount();

  const { isLoading, locationIds } = useAiReceptionistOrgLocations({
    isAllAccessScopeEnabled: false,
    isDemoAccount,
  });

  return !isLoading && locationIds.length > 0;
};
